import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StatsCard } from '../common';
import Update from '@mui/icons-material/Update';
import Work from '@mui/icons-material/Work';
import Done from '@mui/icons-material/Done';
import DoneAll from '@mui/icons-material/DoneAll';

const OfferStats = ({ data }) => {
  const { t } = useTranslation();
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} lg={3}>
        <StatsCard
          icon={Update}
          iconColor='success'
          title={t('Dashboard.TimeToYesAverage')}
          statIcon={Update}
          description={
            data.timeToYesAverage && Number.isFinite(data.timeToYesAverage)
              ? t('NUMBER', { number: Math.floor(+data.timeToYesAverage / 60) }) +
                'h ' +
                t('NUMBER', { number: (+data.timeToYesAverage % 60).toFixed() }) +
                'm'
              : '0h 0m'
          }
          statText={t('Dashboard.TimeToYesAverage')}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <StatsCard
          icon={Work}
          iconColor='warning'
          title={t('Dashboard.TimeToPayAverage')}
          statIcon={Work}
          description={
            data.timeToPayAverage && Number.isFinite(data.timeToPayAverage)
              ? t('NUMBER', { number: Math.floor(+data.timeToPayAverage / 60) }) +
                'h ' +
                t('NUMBER', { number: (+data.timeToPayAverage % 60).toFixed() }) +
                'm'
              : '0h 0m'
          }
          statText={t('Dashboard.TimeToPayAverage')}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <StatsCard
          icon={Done}
          iconColor='primary'
          title={t('Dashboard.Rework')}
          statIcon={Done}
          description={
            data.rework && Number.isFinite(data.rework) ? t('DECIMAL', { number: Number(data.rework * 100).toFixed(2) }) + '%' : '0%'
          }
          statText={t('Dashboard.Rework')}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <StatsCard
          icon={DoneAll}
          iconColor='success'
          title={t('Dashboard.Volume')}
          statIcon={DoneAll}
          description={
            <div style={{ display: 'block' }}>
              {data.offerCount && Number.isFinite(data.offerCount) && (
                <Typography style={{ fontSize: '0.725em', textAlign: 'right' }}>
                  {t('Dashboard.OfferNumber')}
                  {t('NUMBER', { number: data.offerCount })}
                </Typography>
              )}
              {data.volume && Number.isFinite(data.volume) && (
                <Typography style={{ fontSize: '0.725em', textAlign: 'right' }}>
                  {t('Dashboard.VolumeIndicator')}
                  {t('DECIMAL', { number: data.volume })}
                  {' RON'}
                </Typography>
              )}
            </div>
          }
          statText={t('Dashboard.Volume')}
        />
      </Grid>
    </Grid>
  );
};
OfferStats.propTypes = {
  data: PropTypes.object.isRequired
};

export default OfferStats;
